export default __webpack_public_path__ + "static/media/group.b90a17fc.png";